/* eslint-disable react/no-danger*/
/* eslint curly: 0*/
import React from 'react';
import {connect} from 'react-redux';
import {bindMethods} from '../../shared/utilities/componentHelpers';
import styles from './css/Error.styl';
import {LegacycomIcon, SearchIcon} from '../../shared/Svgs';

const logoObituaries = require('./assets/obituaries.png');
const logoFuneralHomes = require('./assets/funeral_homes.png');
const logoNewspapers = require('./assets/newspapers.png');
const logoHistory = require('./assets/history.png');
const logoCelebrity = require('./assets/celebrity.png');

/**
 * Error page module
 * @class   Person
 * @return  {JSX} Returns the rendered module
 */
export class Error extends React.Component {
  static propTypes = {
    error: React.PropTypes.object,
    mobileDetails: React.PropTypes.object,
  };

  /**
   * constructs values for the class to use
   * @param  {object}     props - passed in props
   * @return {undefined}  returns nothing
   */
  constructor(props) {
    super(props);

    this.state = {
      referrer: 'none',
      IE: 0,
      slim: false,
    };

    bindMethods(this, ['handleResize', 'handleGoBack']);
  }

  /**
   * Lifecycle method
   * @return {Undefined} Returns nothing
   */
  componentDidMount() {
    const WAIT = 500;

    window.addEventListener('resize', this.handleResize);
    this.setReferrer();
    this.checkIE();
    setTimeout(this.handleResize, WAIT);
  }

  /**
   * Remove event listeners.
   * @return {Undefined} Returns nothing
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  checkIE() {
    const undef = null;
    const div = document.createElement('div');
    const all = div.getElementsByTagName('i');
    let version = 3;

    while (
      ((div.innerHTML = `<!--[if gt IE ${++version}]><i></i><![endif]-->`),
      all[0])
    );

    this.setState({IE: version > 4 ? version : undef});
  }

  setReferrer() {
    let referrer = document.referrer;

    if (document.referrer.indexOf('legacy.com') === -1) {
      referrer = 'none';
    }
    this.setState({referrer});
  }

  handleResize() {
    const header = this.refs.header.offsetHeight;
    const content = this.refs.content.offsetHeight;
    const footer = this.refs.footer.offsetHeight;
    const body = this.refs.body.offsetHeight;
    const padding = 100;
    const minWidth = 750;

    if (window.outerWidth > minWidth) {
      if (header + content + footer + padding > body) {
        if (this.state.slim !== true) {
          this.setState({slim: true});
        }
      } else if (this.state.slim !== false) {
        this.setState({slim: false});
      }
    }
  }

  /**
   * Click handler for go back button
   * @return {void} redirects to legacy OR referrer
   */
  handleGoBack() {
    window.open(
      this.state.referrer === 'none'
        ? 'https://www.legacy.com'
        : this.state.referrer,
      '_self'
    );
  }

  /**
   * React Module render.
   * @return {jsx} Error module rendered.
   */
  render() {
    const {
      mobileDetails: {android: {device: isAndroid}} = {device: false},
    } = this.props;

    return (
      <div
        className={
          styles.Error +
          (this.state.slim ? ` ${styles.slim}` : '') +
          (this.state.IE === 9 ? ` ${styles.ie9}` : '')
        }
        ref={'body'}
      >
        <header ref={'header'}>
          <div className={styles.content}>
            <a href="https://www.legacy.com">
              <span className={styles.logo}>
                <LegacycomIcon />
              </span>
            </a>
            <a href="https://www.legacy.com/ns/obitfinder/obituary-search.aspx">
              <div
                className={
                  styles.searchBtn +
                  (isAndroid ? ` ${styles.android}` : '') +
                  (this.state.IE === 9 ? ` ${styles.ie9}` : '')
                }
              >
                <div className={styles.icon}>
                  <SearchIcon />
                </div>
                <p>Search</p>
              </div>
            </a>
          </div>
        </header>
        <section
          className={this.state.slim ? ` ${styles.slim}` : ` ${styles.normal}`}
          ref={'content'}
        >
          <div className={styles.content}>
            <h1>
              We're sorry, but this page is not available. The error has been
              reported to our site, and our best people are investigating.
            </h1>
            <p>
              Error Code:{' '}
              <span className={styles.errorCode}>
                {this.props.error.errorStore.errorCode}
              </span>
            </p>
            <p>
              In the meantime, we invite you to browse obituaries or explore our
              content.
            </p>
            <a onClick={this.handleGoBack}>
              {this.state.referrer === 'none' ? 'Go to Home Page' : 'Go Back'}
            </a>
          </div>
        </section>
        <footer ref={'footer'}>
          <ul>
            <li>
              <a href="https://www.legacy.com/obituaries/local">
                <img src={logoObituaries} />
                <p>
                  Browse
                  <br />
                  Obituaries
                </p>
                <div className={styles.divider} />
              </a>
            </li>
            <li>
              <a href="https://www.legacy.com/funeral-homes">
                <img src={logoFuneralHomes} />
                <p>
                  Browse
                  <br />
                  Funeral Homes
                </p>
                <div className={styles.divider} />
              </a>
            </li>
            <li>
              <a href="https://www.legacy.com/ns/about/newspapers">
                <img src={logoNewspapers} />
                <p>
                  Browse
                  <br />
                  Newspapers
                </p>
                <div className={styles.divider} />
              </a>
            </li>
            <li>
              <a href="https://www.legacy.com/news/explore-history">
                <img src={logoHistory} />
                <p>
                  Explore
                  <br />
                  History
                </p>
                <div className={styles.divider} />
              </a>
            </li>
            <li>
              <a href="https://www.legacy.com/news/celebrity-deaths">
                <img src={logoCelebrity} />
                <p>
                  Celebrity
                  <br />
                  Deaths
                </p>
              </a>
            </li>
          </ul>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.errorStore,
  mobileDetails: state.mobileDetailsStore,
});

export default connect(mapStateToProps)(Error);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Error/Error.js